import { Chip, Grid2, Paper, Typography, useTheme } from '@mui/material';
import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import DragAndDrop from '../../../Components/Form/DragAndDrop/drag-and-drop.component';
import { Input } from '../../../Components/Form/Input/input.component';
import { InputCurrency } from '../../../Components/Form/InputCurrency/input-currency.component';
import InputMaskComponent from '../../../Components/Form/InputMask/input-mask.component';
import RichTextEditor from '../../../Components/Form/RichTextEditor/rich-text-editor.component';
import { Checkbox } from '../../../Components/Form/Checkbox/checkbox.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { CreateProductUseCase } from '../../../Usecase/Products/create-product-usecase';

import { FaQrcode } from 'react-icons/fa';
import { Can } from '../../../Components/Can';
import { InternalCodeDrawer } from '../../../Components/Dialog/variants/internal-code/internal-code-dialog.component';
import { CatetoryListDrawer } from '../../../Components/Drawer/variants/category-list/category-list-drawer.component';
import { ProductsCubageSelectDrawer } from '../../../Components/Drawer/variants/products-cubage-select/products-cubage-select-drawer.component';
import { SeoFormDrawer } from '../../../Components/Drawer/variants/seo-form/seo-form-drawer.component';
import { VariantsListDrawer } from '../../../Components/Drawer/variants/variants-list/variants-list-drawer.component';
import { Radio } from '../../../Components/Form/Radio/radio-input.component';
import { SelectComponent } from '../../../Components/Form/Select/select.component';
import { brandMockOptions } from '../../../Config/shared';
import { ListCategoriesUseCase } from '../../../Usecase/Categories/list-categories-usecase';
import { ListCubagesUseCase } from '../../../Usecase/Cubages/list-cubages-usecase';
import { ShowProductUseCase } from '../../../Usecase/Products/show-product-usecase';
import { UpdateProductUseCase } from '../../../Usecase/Products/update-product-usecase';
import { ListProductsServiceUseCase } from '../../../Usecase/ProductsService/list-products-service-usecase';
import { ListProductVariantsServiceUseCase } from '../../../Usecase/ProductVariants/list-product-variants-usecase';
import { ListServiceInfoOrdersUseCase } from '../../../Usecase/ServicesInfo/list-service-info-usecase';
import { billingOptions, useCreateProducts } from './create-products-hook';
import { SelectedPoliciesDisplay, SelectPricePoliciesVariant } from '../../../Components/Modals/variants/select-price-policies';
import { ListPricePoliciesUseCase } from '../../../Usecase/PricePolicies/list-price-policies-usecase';
import { TinyMceEditor } from '../../../Components/Form/TinyMceEditor/tiny-mce-editor.component';
import { GetMaskProductOptionsUseCase } from '../../../Usecase/Products/get-mask-product-options-usecase';



  interface IProductsFormProps {
    createProductUseCase: CreateProductUseCase
    listCubagesUseCase: ListCubagesUseCase
    listProductsServiceUseCase: ListProductsServiceUseCase
    listServiceInfoOrdersUseCase: ListServiceInfoOrdersUseCase
    showProductUseCase: ShowProductUseCase
    updateProductUseCase: UpdateProductUseCase
    listCategoriesUseCase: ListCategoriesUseCase
    listProductVariantsServiceUseCase: ListProductVariantsServiceUseCase
    listPricePoliciesUseCase: ListPricePoliciesUseCase
    getMaskProductOptionsUseCase: GetMaskProductOptionsUseCase
  }
const ProductsForm : FC<IProductsFormProps> = ({ createProductUseCase, listCubagesUseCase, listProductsServiceUseCase,listServiceInfoOrdersUseCase, showProductUseCase, updateProductUseCase, listCategoriesUseCase, listProductVariantsServiceUseCase, listPricePoliciesUseCase, getMaskProductOptionsUseCase }) => {
   
    const theme = useTheme()
    const navigate = useNavigate()
    const params = useParams()
   

    const { control, errors, handleAction, handleSubmit, loading, isDataLoaded, register, watch, handleSelectCategories, showCategoriesModal, showSEOModal, images, maskSchema, setMaskSchema, setShowCategoriesModal, setShowCubageModal, setShowInternalCode, setShowSEOModal, setShowVariationsModal, setVariations, showCubageModal, showInternalCode, showVariationsModal, cubagesList, variations, handleListCubages, categories, setCategories, dragAndDropRef, handleListProductsServices, billingTypeValue, productsServicesOptions, cubagesSelected, handleRemoveTemporary, handleAddTemporary, storeTypeOptions, nsStoreValue, listCategories, categoriesSelected, data, setCategoriesSelected,  handlePricePoliciesChange, handleAddVariation, handleRemoveVariation, handleRemoveValue, 
      showPricePoliciesModal,
        openPricePoliciesModal,
        closePricePoliciesModal,
        handleSelectPricePolicies,
        selectedPolicies,
        removePolicy,
        maskOptions,
        
      } = useCreateProducts({
      createProductUseCase,
      listCubagesUseCase,
      listProductsServiceUseCase,
      listServiceInfoOrdersUseCase,
      showProductUseCase,
      updateProductUseCase,
      listCategoriesUseCase,
      getMaskProductOptionsUseCase
    })

    useEffect(() => {
      handleListCubages()
      handleListProductsServices()
      // listCategories()
    }, [])

 
    const createOnNuvemShopB2B = watch('createOnNuvemShopB2B')
    const createOnNuvemShopB2C = watch('createOnNuvemShopB2C')

    return (
      <Can permissions={['menu:products:manage']}>
        <BaseScreen>
        {showPricePoliciesModal && (
          <SelectPricePoliciesVariant
            onClose={closePricePoliciesModal}
            onSelect={handleSelectPricePolicies}
            listPricePoliciesUseCase={listPricePoliciesUseCase}
            selectedPolicies={selectedPolicies}
            multiple={true}
          />
        )}

            <CatetoryListDrawer
               handleSelect={e => handleSelectCategories(e)} 
               open={showCategoriesModal} 
               title={nsStoreValue === 'createOnNSEmpo' ? 'Marca' : 'Categoria'}
               onToggle={() => setShowCategoriesModal(prev => !prev)} 
              //  subTitle={`Cadastre uma nova ${nsStoreValue === 'createOnNSEmpo' ? 'Marca' : 'Categoria'}`} 
               type={nsStoreValue} 
              //  categories={categories}
              categories={maskOptions?.brands} 
              control={control}
            />

            <SeoFormDrawer handleSelect={e => {}} open={showSEOModal} title='Tags' onToggle={() => setShowSEOModal(prev => !prev)} subTitle='Cadastre os conteúdos de SEO para otimizar suas buscas.' containerStyle={{ width: '540px' }} />
            
            <ProductsCubageSelectDrawer  handleSelect={e => {}} open={showCubageModal} title='Cubagem' onToggle={() => setShowCubageModal(prev => !prev)} subTitle='Selecione a cubagem deste produto' cubages={cubagesList} control={control} handleAddTemporaryCubage={handleAddTemporary} handleRemoveTemporary={handleRemoveTemporary} />

            <InternalCodeDrawer  handleSelect={e => setMaskSchema(e)} open={showInternalCode}  onToggle={() => setShowInternalCode(prev => !prev)} title='Código Interno' code={maskSchema?.generatedMaskName || ''} initialMaskSchema={maskSchema} options={maskOptions}  />

            <VariantsListDrawer 
              handleSelect={e => {}} 
              open={showVariationsModal} 
              title='Variações' 
              onToggle={() => setShowVariationsModal(prev => !prev)} 
              subTitle='Cadastre uma nova variação' 
              listProductVariantsServiceUseCase={listProductVariantsServiceUseCase}
              variations={variations}
              onAddVariation={handleAddVariation}
              onRemoveVariation={handleRemoveVariation}
              onRemoveValue={handleRemoveValue}
            />

   
            <Paper>
                <BaseContentPage 
                    title='Produtos'
                    breadcrumb={[{ title: 'Produtos', link: "/products-list"}, { title: 'Novo Produto'}]}
                >

                  {(loading || (params.id && !data?.id)) ? <Loader /> : (
                    <>
                       <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>

                        {/* <Grid2 size={6}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                              <Radio
                                  label="Cadastrar em qual loja"
                                  labelStyle={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px'}}
                                  name="nsStore"
                                  control={control}
                                  options={storeTypeOptions}
                                  error={!!errors.nsStore}
                                  helperText={errors?.nsStore?.message}
                                  flex
                                  defaultValue={data?.store}
                              />   
                        </Grid2> */}

                        <Grid2 size={12} container spacing={2} alignItems="center">
                          <Grid2 size={3}>
                              <Checkbox
                                  label="Cadastrar na Nuvem Shop - B2B"
                                  name="createOnNuvemShopB2B"
                                  defaultValue={!!data?.createOnNuvemShopB2B}
                                  control={control}

                              />
                          </Grid2>

                          {createOnNuvemShopB2B && (
                            <Grid2 size={4}>
                                <InputCurrency 
                                    label="Preço Unitário B2B"
                                    placeholder="Preencha o preço"
                                    name="b2bNuvemShopPrice"
                                    control={control}
                                    error={!!errors.b2bNuvemShopPrice}
                                    helperText={errors.b2bNuvemShopPrice?.message} />
                            </Grid2>
                          )}
                        </Grid2>

                          <Grid2 size={12} container spacing={2} alignItems="center">
                            <Grid2 size={3}>
                                <Checkbox
                                    label="Cadastrar na Nuvem Shop - B2C"
                                    name="createOnNuvemShopB2C"
                                    defaultValue={!!data?.createOnNuvemShopB2B}
                                    control={control}
                                  
                                />
                            </Grid2>

                            {createOnNuvemShopB2C && (
                              <Grid2 size={4}>
                                    <InputCurrency 
                                        label="Preço Unitário B2C"
                                        placeholder="Preencha o preço"
                                        name="b2cNuvemShopPrice"
                                        control={control}
                                        error={!!errors.b2cNuvemShopPrice}
                                        helperText={errors.b2cNuvemShopPrice?.message} />
                                </Grid2>
                            )}
                          </Grid2>


                          

                        <Grid2 size={3}>
                          <Typography sx={{marginBottom: '10px', fontSize: '19px', fontWeight: '600'}}>Tipo de Produto</Typography>
                          
                          <Checkbox label="Produto Personalizável?" name="personalized" control={control} defaultValue={!!data?.personalized} />
                        </Grid2>

                        <Grid2 size={watch('isResale') ? 3 : 9}>
                          <Typography sx={{marginBottom: '10px', fontSize: '19px', fontWeight: '600'}}>Produto de Revenda</Typography>
                          
                          <Checkbox label="Produto de Revenda?" name="isResale" control={control} defaultValue={!!data?.isResale} />
                        </Grid2>

                        {watch('isResale') && (
                          <Grid2 size={6}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                              <Input
                                  label="Código OMIE (matéria prima)"
                                  placeholder="Preencha o código OMIE (matéria prima)"
                                  error={!!errors.omieRawMaterialCode}
                                  helperText={errors.omieRawMaterialCode?.message}
                                  {...register('omieRawMaterialCode')}
                              />
                          </Grid2>
                          )}










                        {/* <Typography sx={{fontSize: '19px', fontWeight: '600'}}>ERP (Omie) - Configurações</Typography>

                        <Grid2 size={12} container sx={{
                          width: '100%',
                          padding: '20px',
                          border: '2px dashed #ccc',
                          borderRadius: '8px',
                          marginTop: -4
                        }}>

                        <Grid2 size={3}>
                            <Switch
                                label="Cadastrar na Empo"
                                name="createOnOmie"
                                control={control}

                            />
                        </Grid2>

                        <Grid2 size={3}>
                            <Switch
                                label="Cadastrar na Papello"
                                name="createOnNuvemShop"
                                control={control}
                              
                            />
                        </Grid2>

                            
                        </Grid2> */}

                       
                    
                          <Grid2 size={billingTypeValue !== 'service' ? 12 : 3}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                              <Radio
                                  label="Como será faturado"
                                  labelStyle={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px'}}
                                  name="billingType"
                                  control={control}
                                  options={billingOptions}
                                  error={!!errors.billingType}
                                  helperText={errors?.billingType?.message}
                                  defaultValue={data?.billingType}
                              />   
                          </Grid2>

                          {billingTypeValue === 'service' && (
                          <Grid2 size={9}  sx={{ minWidth: '150px', flex: '0 0 auto' }}>
                              <Typography sx={{marginBottom: '10px', fontSize: '19px', fontWeight: '600'}}>Selecione o Serviço:</Typography>
                                <SelectComponent name='productServiceId' label='Serviço' options={productsServicesOptions} control={control} error={!!errors?.service} helperText={errors?.service?.message || ''} defaultValue={data?.productService?.id} placeholder=''  />
                            
                          </Grid2>
                          )}

                         

                          <Typography sx={{fontSize: '19px', fontWeight: '600'}}>{nsStoreValue === 'createOnNSEmpo' ? 'Marca' : 'Categorias'}</Typography>
                          <Grid2 size={12} container sx={{
                            width: '100%',
                            padding: '20px',
                            border: '2px dashed #ccc',
                            borderRadius: '8px',
                            marginTop: -4
                          }}>
                          

                        <Grid2 size={12} container spacing={2}>
                            {!categoriesSelected?.length && <Typography mb='10px'>Você ainda não possui nenhuma {nsStoreValue === 'createOnNSEmpo' ? 'Marca' : 'Categorias'} selecionada.</Typography>}

                            {categoriesSelected?.map(item => {
                              return   <Chip 
                                          key={item.value} 
                                          label={item.label} 
                                          onDelete={() => setCategoriesSelected(categoriesSelected.filter((t) => t.value !== item.value))} 
                                          sx={{ fontSize: '14px'}}
                                        />
                                          
                              // <Tag title={item} onClose={() => {}} />
                            })}
                          
                        </Grid2>

                        <Grid2 size={12}>
                        <Button onClick={() => setShowCategoriesModal(true)} sx={{ width: '300px', marginTop: '25px' }} isLoading={loading}>
                            Adicionar {nsStoreValue === 'createOnNSEmpo' ? 'Marca' : 'Categorias'}
                        </Button>
                            </Grid2>
                          
                          </Grid2>

                          <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Tags</Typography>
                          <Grid2 size={12} container sx={{
                              width: '100%',
                              padding: '20px',
                              border: '2px dashed #ccc',
                              borderRadius: '8px',
                              marginTop: -4
                            }}>
                              

                            <Grid2 size={12} container spacing={2}>
                            <Typography mb='10px'>Atualmente as tags são gerenciadas pelo painel B2B da Nuvem Shop.</Typography>
                                {/* {!categories?.length && <Typography mb='10px'>Você ainda não possui nenhum conteúdo cadastrado.</Typography>} */}
                            
                              
                            </Grid2>

                            {/* <Grid2 size={12}>
                            <Button onClick={() => setShowSEOModal(true)} sx={{ width: '300px', marginTop: '25px' }} isLoading={loading}>
                                Adicionar Conteúdo
                            </Button>
                            </Grid2> */}

                          </Grid2>

                          <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Cubagem</Typography>
                          <Grid2 size={12} container sx={{
                              width: '100%',
                              padding: '20px',
                              border: '2px dashed #ccc',
                              borderRadius: '8px',
                              marginTop: -4
                            }}>
                              

                            <Grid2 size={12} container spacing={2}>
                              {!!cubagesSelected?.length ?  cubagesSelected?.map(i => <Chip 
                                      key={i.id} 
                                      label={`${i?.cubageVariant?.description} - ${i?.cubageVariant?.howManyInBox} Unidades`} 
                                      onDelete={() => handleRemoveTemporary(i)} 
                                      sx={{ fontSize: '14px'}}
                                    />) : <Typography mb='10px'>Você ainda não possui nenhuma cubagem cadastrado.</Typography>}
                            
                            </Grid2>

                            <Grid2 size={12}>
                            <Button onClick={() => setShowCubageModal(true)} sx={{ width: '300px', marginTop: '25px' }} isLoading={loading}>
                                Selecionar cubagem
                            </Button>
                            </Grid2>

                          </Grid2>

                          <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Variações</Typography>
                          <Grid2 size={12} container sx={{
                              width: '100%',
                              padding: '20px',
                              border: '2px dashed #ccc',
                              borderRadius: '8px',
                              marginTop: -4
                            }}>
                              {/* <Typography>As variações devem ser cadastradas/editadas diretamente na Nuvem Shop</Typography> */}
                              

                            <Grid2 size={12} container spacing={2}>
                                {!variations?.length && <Typography>Você ainda não possui nenhuma variação cadastrada.</Typography>}
                                
                                {variations?.map((variation, index) => (
                                  <Grid2 size={12} key={index} sx={{ marginBottom: '10px' }}>
                                    <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
                                      {variation.variationType}:
                                    </Typography>
                                    <Grid2 container spacing={1}>
                                      {variation.values.map((value, valueIndex) => (
                                        <Chip
                                          key={valueIndex}
                                          label={`Multiplicador: ${value} | Quantidade: ${variation.howManySteps}`}
                                          sx={{ fontSize: '12px', margin: '2px' }}
                                        />
                                      ))}
                                    </Grid2>
                                  </Grid2>
                                ))}
                              
                            </Grid2>

                            <Grid2 size={12}>
                              <Button onClick={() => setShowVariationsModal(true)} sx={{ width: '300px' }} isLoading={loading}>
                                  Adicionar Variação
                              </Button>
                            </Grid2>
                          </Grid2>

                          <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Política de Preço</Typography>
                          <Grid2 size={12} container sx={{
                              width: '100%',
                              padding: '20px',
                              border: '2px dashed #ccc',
                              borderRadius: '8px',
                              marginTop: -4
                            }}>
                              {/* <Typography>As variações devem ser cadastradas/editadas diretamente na Nuvem Shop</Typography> */}
                              


                            <Grid2 size={12} container spacing={2}>
                              
                                  <SelectedPoliciesDisplay
                                    selectedPolicies={selectedPolicies}
                                    onRemovePolicy={(policyId: string) => removePolicy(policyId)}
                                    variant="detailed"
                                  />
                              
                            </Grid2>

                            <Grid2 size={12}>
                              <Button onClick={openPricePoliciesModal} sx={{ width: '300px' }} isLoading={loading}>
                                  Adicionar Política
                              </Button>
                            </Grid2>
                          </Grid2>

                        

                          <Grid2 size={4}>
                              <Input
                                  label="SKU"
                                  placeholder="Preencha o SKU"
                                  error={!!errors.code}
                                  helperText={errors.code?.message}
                                  {...register('code')}
                              />
                          </Grid2>

                          <Grid2 size={4}>
                              <Input
                                  label="Código Mestre (Engenharia)"
                                  placeholder="Preencha o código mestre (engenharia)"
                                  error={!!errors.masterCode}
                                  helperText={errors.masterCode?.message}
                                  {...register('masterCode')}
                              />
                          </Grid2>

                          <Grid2 size={4} spacing={2} sx={{ display: 'flex', gap: '10px'}}>
                              <Input
                                  label="Código interno (Máscara)"
                                  placeholder="Selecione o código interno (máscara)"
                                  disabled
                                  sx={{ width: '90%'}}
                                  value={maskSchema?.generatedMaskName || ''}
                                  {...register('maskCode')}
                              />
                              <Button  onClick={() => setShowInternalCode(true)} sx={{ width: '20px', height: '100%' }} isLoading={loading}>
                              <FaQrcode size={25} style={{ marginTop: '5px'}} color='#fff' />
                            </Button>
                          </Grid2>

                          <Grid2 size={4}>
                              <Input
                                  label="Nome Importado"
                                  placeholder="Preencha o nome"
                                  disabled
                                  error={!!errors.internalName}
                                  helperText='Para montar esse nome, selecione a máscara no campo Código Interno (Máscara)'
                                  {...register('internalName')}
                                  value={maskSchema?.generatedMaskInternalName || ''}
                                  
                              />
                          </Grid2>

                          <Grid2 size={4}>
                              <Input
                                  label="Nome Amigável"
                                  placeholder="Preencha o nome"
                                  error={!!errors.name}
                                  helperText={errors.name?.message}
                                  {...register('name')}
                              />
                          </Grid2>

                          

                          <Grid2 size={4}>
                            <InputMaskComponent
                              label="NCM"
                              helperText='Nomenclatura Comum do Mercosul'
                              placeholder="Preencha o NCM"
                              mask='9999.99.99'
                              name="ncm"
                              control={control}
                            />
                            
                          </Grid2>

                          {/* {createOnNuvemShopB2B && ( */}
                            <Grid2 size={4}>
                              <Input
                                  label="Link da arte"
                                  placeholder="Preencha o link"
                                  {...register('artLink')}
                              />
                            </Grid2>
                          {/* )} */}

                        

                          <Grid2 size={12} >
                            
                                  <TinyMceEditor name="description" control={control} />
                            
                          </Grid2>

                          <Grid2 size={12} sx={{ marginTop: 5}}>
                              <DragAndDrop  ref={dragAndDropRef} />
                          </Grid2>

                          <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                              SALVAR
                          </Button>
                        

                        



                        </Grid2>
                    </>
                  )}

                 
                   
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { ProductsForm };
